import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["swap", "themeInput"];
  static values = {
    current: String,
    next: String,
  };

  connect() {
    if (this.currentValue === "night") {
      this.swapTarget.classList.add("swap-active");
    }
  }

  toggle(event) {
    event.preventDefault();

    this.swapTarget.classList.toggle("swap-active");

    document.documentElement.setAttribute("data-theme", this.nextValue);
    if (this.nextValue === "night") {
      document.querySelector("meta[name='theme-color']").content = "#38bdf8";
    } else {
      document.querySelector("meta[name='theme-color']").content = "#0D0D0D";
    }

    // submit before we swap the values
    this.element.requestSubmit();

    const oldCurrent = this.currentValue;
    this.currentValue = this.nextValue;
    this.nextValue = oldCurrent;

    this.themeInputTarget.value = this.nextValue;
  }
}
